module.exports = __webpack_public_path__ + "static/img/user-pick-benefit-detail-banner.12f4d6b.jpg";